<template>
    <shinsei-no-approval-form />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import ShinseiNoApprovalForm from '@/components/shinsei/create/NoApprovalForm.vue'

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'shinsei-no-approval-form': ShinseiNoApprovalForm
    }
})
</script>
